"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDown = _interopRequireDefault(require("./IconArrowDown"));
var IconArrowUp = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDown.default).withConfig({
  displayName: "IconArrowUp",
  componentId: "c11n-8-107-0__sc-sxqevw-0"
})(["transform:rotate(180deg);"]);
var _default = IconArrowUp;
exports.default = _default;